import React from 'react';
import { Box } from '@mui/material/';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { BrowserView, MobileView } from 'react-device-detect';

const f4 = "https://firebasestorage.googleapis.com/v0/b/ontime-972c6.appspot.com/o/E2%2Fe2_floor4.png?alt=media&token=a18a1f5d-4a42-4a2c-b2da-6b90faa7a718";

export default function bsoeF1() {
    let image_width = 1173.9;
    let image_height = 282.8;
    return (
        <>
        <BrowserView>
            <Box marginLeft={35} marginTop={0.5}>
                <TransformWrapper>
                    <TransformComponent>
                        <img src={f4} alt="f4" width={1173.9} height={282.8} />
                    </TransformComponent>
                </TransformWrapper>
            </Box>
        </BrowserView>
        <MobileView>
        <Box alignItems="center"
                display="flex"
                justifyContent="center"
                marginBottom={5}
                // marginRight={1}
                // marginTop={1}
                // maxWidth="100%"
                // overflow="hidden"
                padding="0 3%" // Adjust the percentage to change the margin on both sides
                // width="100%"
                >
                    <TransformWrapper>
                        <TransformComponent>
                            <img src={f4} alt="f4" width={image_width/2.5} height={image_height/2.5} />
                        </TransformComponent>
                    </TransformWrapper>
                </Box>
        </MobileView>
        </>
    );
}